/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */


import { Properties, PublicProperties } from '@api/model';
import { IAction } from '../../models/IshAction';
import { GET_PUBLIC_PROPERTIES_FULFILLED, GET_SYSTEM_PROPERTIES_FULFILLED } from '../actions/SystemProperties';

export const systemPropertiesReducer = (state: Properties = {}, action: IAction): Properties => {
  switch (action.type) {
    case GET_SYSTEM_PROPERTIES_FULFILLED:
      return {
        ...state,
        ...action.payload,
      };
    case GET_PUBLIC_PROPERTIES_FULFILLED:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return {
        ...state
      };
  }
};